import React from 'react'
import PropTypes from 'prop-types'

import UnitExercise from 'src/ui/UnitExercise/UnitExercise'
import routes from 'src/lib/rails-routes/rails-routes'
import { t } from 'src/lib/i18n-react'

import UnitExerciseListSkeleton from './UnitExerciseListSkeleton'

const Exercises = ({ exercises, showExerciseRating, l2Code }) => {
  return exercises.map((item, index) => {
    return (
      <UnitExercise
        key={`exercise-${index}`}
        item={item}
        linkUrl={routes.exercises_show(l2Code, item.id)}
        showExerciseRating={showExerciseRating}
      />
    )
  })
}

const UnitExerciseList = ({ exercises, l2Code, showExerciseRating }) => {
  return (
    <UnitExerciseListSkeleton
      titleSection={t('Live Lesson Exercises')}
      listSection={
        <Exercises
          exercises={exercises}
          showExerciseRating={showExerciseRating}
          l2Code={l2Code}
        />
      }
    />
  )
}

UnitExerciseList.propTypes = {
  exercises: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  showExerciseRating: PropTypes.bool.isRequired,
  l2Code: PropTypes.string.isRequired,
}

export default UnitExerciseList
